var _a;
import 'styles/index.scss';
import '@fontsource/inter/variable-full.css';
import * as FullStory from '@fullstory/browser';
import { enableMapSet } from 'immer';
import React from 'react';
import { createRoot } from 'react-dom/client';
import ReactGA from 'react-ga';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import App from './app';
import * as serviceWorker from './serviceWorker';
import store from './store.js';
enableMapSet();
window.dispatchAction = (type, payload) => store.dispatch({ type, payload });
window.debugLogger = (msg) => {
    if (localStorage.getItem('debug-logging') !== 'true')
        return;
    console.log(msg);
};
ReactGA.initialize(window.RG_CONFIG.GA_TRACKING_ID);
FullStory.init({ orgId: window.RG_CONFIG.FULLSTORY_ORG_ID });
const router = createBrowserRouter([
    {
        path: '*',
        element: React.createElement(App, null),
    },
]);
const root = createRoot(document.getElementById('root'));
root.render(React.createElement(RouterProvider, { router: router }));
serviceWorker.unregister();
if (window.RG_CONFIG.ENVIRONMENT === 'local') {
    (_a = module === null || module === void 0 ? void 0 : module.hot) === null || _a === void 0 ? void 0 : _a.accept();
}
